import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CustomLink from '../../../components/Navbar/CustomLink';
import { RootState } from '../../../state/store'; // cesta podle toho, kde máš store
import { clearUserInfo } from '../../../state'; // globalSlice actions
import styles from './Header.module.css';

export const Header = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: RootState) => state.global.userInfo);
  const location = useLocation();
  const isClientRoute = location.pathname.startsWith('/client');

  const logout = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/logout`, {
        credentials: 'include',
        method: 'POST',
      });
    } catch (err) {
      console.error('Logout error:', err);
    }
    dispatch(clearUserInfo());
  };

  return (
    <header className="flex justify-between items-center p-4 shadow-md">
      <CustomLink to="/" className="logo font-bold text-lg">
        SmartPush
      </CustomLink>
      <nav className="flex gap-4 items-center">
        {userInfo?.email ? (
          <>
            <span className="text-sm text-gray-700">
              Ahoj,{' '}
              <strong>
                {userInfo.email}, {userInfo.id}, {userInfo.role}
              </strong>
            </span>
            {!isClientRoute && <CustomLink to="/create">Vytvořit nový post</CustomLink>}
          </>
        ) : (
          <>
            <CustomLink to="/login">Login</CustomLink>
            <CustomLink to="/register">Register</CustomLink>
          </>
        )}
        {userInfo?.email && (
          <button onClick={logout} className={styles.logoutButton}>
            Odhlásit se
          </button>
        )}
      </nav>
    </header>
  );
};
